import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorComponentBase } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-number-input-editor',
    templateUrl: './number-input-editor.component.html',
    styleUrls: ['./number-input-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ValidationErrorMessageComponent]
})
export class NumberInputEditorComponent extends EditorComponentBase<number> {
    constructor() {
        super();
    }

    dataChanged() {
        this.valueChange.emit();
        this.validate();
    }
}
